import { render } from "./terms_modal.html?vue&type=template&id=5ab0fb64&external"
import script from "./terms_modal.js?vue&type=script&lang=js&external"
export * from "./terms_modal.js?vue&type=script&lang=js&external"

import "@/assets/css/index.css?vue&type=style&index=0&lang=css&external"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__